mutation DeleteUsers($ids: [ID!]!) {
  deleteUsers(ids: $ids) {
    id
    deletedAt
  }
}
